import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import notify from 'devextreme/ui/notify';
import { InvoiceService } from '../../../providers/invoice.service';

@Component({
  selector: 'app-change-invoice',
  templateUrl: './change-invoice.component.html',
  styleUrls: ['./change-invoice.component.scss']
})
export class ChangeInvoiceComponent implements OnInit {
  invoice;
  servicePrices;
  @Output() done: EventEmitter<boolean> = new EventEmitter<boolean>();
  constructor(public invoiceService: InvoiceService,
    public activeModal: NgbActiveModal) { }

  ngOnInit() {
    this.invoiceService.apiCall('api/service/getTypePrices',
      { username: this.invoice.username, servicetype: this.invoice.service_type }).subscribe((result: any) => {
        this.servicePrices = result;
      }, error => {
        notify(error.message || error, 'error', 5000);
      });
  }

  ok(invoice) {
    this.invoiceService.changeServicePrice(invoice).subscribe((result: any) => {
      this.activeModal.dismiss('job done');
      this.done.emit(true);
    }, error => {
      notify(error.message || error, 'error', 5000);
    });
  }

}
